import { History } from "lucide-react";

import { quando } from "./SeloReaberto";

const brl = (v) => `R$ ${(Number(v) || 0).toFixed(2).replace(".", ",")}`;
const formas = (lista) => (lista || []).map((f) => `${f.nome || f.forma} ${brl(f.valor)}`).join(" + ") || "—";

/** Linha do tempo da reabertura no detalhe do pedido: como estava e como ficou. */
export default function HistoricoReabertura({ historico }) {
  if (!historico?.length) return null;
  return (
    <div className="rounded-lg border border-sky-200 dark:border-sky-900/50 bg-sky-50/60 dark:bg-sky-950/20 p-2 space-y-1" data-e2e="historico-reabertura">
      <p className="text-[11px] font-semibold flex items-center gap-1 text-sky-800 dark:text-sky-300"><History className="w-3 h-3" />Histórico de reabertura</p>
      {historico.map((h, i) => (
        <p key={i} className="text-[11px] text-muted-foreground leading-snug">
          {h.tipo === "reabertura"
            ? <>Reaberto por <b className="text-foreground">{h.por || "—"}</b> em {quando(h.created_at)} · antes: {formas(h.formas)} ({brl(h.total)})</>
            : <>Fechado de novo em {quando(h.created_at)} · {formas(h.formas)} ({brl(h.total)})</>}
        </p>
      ))}
    </div>
  );
}
